import { useCallback, useEffect, useReducer } from "react";
import {
  creditAlertsInitialState,
  creditAlertsReducer,
} from "./creditAlerts.reduse";
import { getCreditHistory } from "../../CreditHistory/api/credithistory.api";
import {
  createCreditAlerts,
  deleteCreditAlerts,
  getCreditAlerts,
} from "../api/creditAlerts.api";
import { setToast } from "./creditAlerts.actions";
import { validateCreditAlertForm } from "./creditAlertsValidation";

export const useCreditAlertsViewModel = () => {
  const [state, dispatch] = useReducer(
    creditAlertsReducer,
    creditAlertsInitialState,
  );
  const showToastMessage = (
    message: string,
    type: "success" | "error" | "warning" | "info",
  ) => dispatch(setToast({ isVisible: true, message, type }));

  const getCreditAlertData = useCallback(async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });

      const resp = await getCreditAlerts();

      dispatch({
        type: "SET_CREDIT_ALERTS",
        payload: resp.data,
      });
    } catch (error) {
      console.error("Error fetching credit alerts:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }, []);
  const deleteCreditAlert = useCallback(async (id: string) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      await deleteCreditAlerts(id);
      showToastMessage("Credit alert deleted successfully", "success");
      dispatch({ type: "SET_DELETE_ALERT_DIALOG_OPEN", payload: false });
      await getCreditAlertData();
    } catch (error) {
      console.error("Error deleting credit alert:", error);
      showToastMessage("Failed to delete credit alert", "error");
      dispatch({ type: "SET_DELETE_ALERT_DIALOG_OPEN", payload: false });
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }, []);
  const getCreditHistoryData = async () => {
    try {
      const errors = validateCreditAlertForm(state.formData);

      if (Object.keys(errors).length > 0) {
        dispatch({ type: "SET_FORM_ERRORS", payload: errors });
        return;
      }
      const resp = await createCreditAlerts(state.formData);
      dispatch({ type: "SET_CREDIT_ALERT_DIALOG_OPEN", payload: false });
      showToastMessage("Credit alert created successfully", "success");
      await getCreditAlertData();
    } catch (error) {
      console.error("Error creating credit alert:", error);
      showToastMessage("Failed to create credit alert", "error");
    }
  };
  useEffect(() => {
    getCreditAlertData();
  }, [getCreditAlertData]);
  return {
    getCreditAlertData,
    getCreditHistoryData,
    state,
    dispatch,
    deleteCreditAlert,
  };
};
